import Vue from 'vue'
import App from './App.vue'

import 'intersection-observer'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

new Vue({
  render: h => h(App),
  router: new VueRouter({
    mode: 'history',
    routes: []
  })
}).$mount('#app')
